export default "__VITE_PUBLIC_ASSET__917a1a75__"